import * as React from 'react';

export const MapPinPointSelected: React.FunctionComponent<{
  color: string;
  ariaName?: string;
}> = ({ color, ariaName }) => {
  return (
    <svg width="32" height="40" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>{ariaName}</title>
      <path
        d="M15.4645 1.00957L15.4647 1.00956C23.9948 0.709585 31 7.51515 31 15.9536C31 16.9229 30.9075 17.8685 30.7301 18.7912L30.7301 18.7912L30.7285 18.7998L30.7285 18.8001L30.7285 18.8001L30.7284 18.8003L30.7284 18.8004L30.7284 18.8005L30.7284 18.8006L30.7278 18.8037L30.7241 18.8232C30.7227 18.8305 30.7209 18.8396 30.7188 18.8503C30.7156 18.8662 30.7117 18.8858 30.7069 18.909C30.691 18.9864 30.666 19.1034 30.631 19.2548L30.631 19.2548L30.6292 19.2627C30.3983 20.299 30.06 21.2876 29.6224 22.2217L29.6145 22.2387L29.6072 22.2559C28.0572 25.9153 24.4451 32.1236 16.2486 38.9089C16.0968 39.0331 15.8857 39.0263 15.7504 38.9131L15.7469 38.9103C7.54914 32.116 3.93677 25.9072 2.39508 22.2644L2.38904 22.2501L2.38256 22.2361C1.94944 21.295 1.60292 20.2954 1.37259 19.2694L1.36988 19.2573L1.36686 19.2453C1.33005 19.0984 1.30711 18.9904 1.29398 18.9233C1.28741 18.8897 1.28329 18.8663 1.2811 18.8534L1.27931 18.8425L1.27925 18.8421L1.27922 18.8419L1.27661 18.8236L1.27231 18.801C1.00939 17.4206 0.925094 15.9831 1.07132 14.5018L1.07152 14.4998C1.78776 7.08783 7.99419 1.27098 15.4645 1.00957Z"
        fill={color}
        stroke={'white'}
        strokeWidth="2"
      />
      <circle cx="16" cy="16" r="4" fill={'white'} />
    </svg>
  );
};
